import { FC } from 'react';
import { MdClose } from 'react-icons/md';
import ModalComponent from 'components/modal/ModalComponent';
import { useStore } from 'zustand';
import { useMapStore } from '@/stores/map/mapStore';
import { PlaceAutocompleteCustom } from './autocomplete-custom';
import { APIProvider } from '@vis.gl/react-google-maps';
import { API_KEY } from '@/utils/constants';
import IconComponent from '@/components/FlashCards/Icon';
import { Button } from '@/components/button';

interface ModalMapProps {
  modalOpen: boolean;
}

const ModalLocationChange: FC<ModalMapProps> = ({ modalOpen }) => {
  const { setModalLocalChangeOpen, clientLocation } = useStore(
    useMapStore,
    (state) => ({
      setModalLocalChangeOpen: state.setModalLocationChangeOpen,
      clientLocation: state.clientLocation,
    })
  );

  return (
    <ModalComponent
      containerClass='mb-10h-[calc(100vh-14rem)]'
      size='sm'
      isOpen={modalOpen}
      close={() => {
        setModalLocalChangeOpen(false);
      }}
    >
      <APIProvider
        apiKey={API_KEY}
        libraries={['places', 'geometry', 'marker']}
      >
        <div className='flex  flex-col'>
          <div className='flex justify-end rounded border-none px-6 pt-4'>
            <button
              className='flex items-center justify-center rounded-lg p-1'
              onClick={() => {
                setModalLocalChangeOpen(false);
              }}
            >
              <MdClose className='size-4 text-inherit' />
            </button>
          </div>
          <div className='px-12 py-6'>
            <div className='text-start'>
              <div className='pb-6 text-xl'>
                Enter your zip code, city or address to find dealers in your
                location.
              </div>
            </div>
            <div className='flex w-full rounded-full'>
              <span className='inline-flex min-w-fit items-center rounded-s-full border border-e-0 pl-4 pr-2 text-sm'>
                <IconComponent
                  name='MdSearch'
                  className={`h-5 w-5 text-gray-500`}
                />
              </span>
              <div className='relative flex w-full items-center'>
                <PlaceAutocompleteCustom />
              </div>
              <span className='inline-flex min-w-fit items-center rounded-e-full border border-s-0 pl-4 pr-2 text-sm'>
                {clientLocation.manuallySet && (
                  <IconComponent
                    name='MdDone'
                    className={`h-5 w-5 text-green-500`}
                  />
                )}
              </span>
            </div>
            <div className='flex justify-end gap-2 pt-6'>
              <Button
                className={'pill-button'}
                variant='outline'
                title={'Close'}
                onClick={() => setModalLocalChangeOpen(false)}
              >
                Close
              </Button>
            </div>
          </div>
        </div>
      </APIProvider>
    </ModalComponent>
  );
};

export default ModalLocationChange;
